<template>
<div class="site-drawer " >
	<el-menu default-active="-1" class="app-side-menu" :router="true">
		<el-menu-item index="/home" v-if="$route.path!='/home' && $centro.profile.row.step>2">Home</el-menu-item>

		<el-submenu index="centro" v-if="$centro.profile.row.step>2">
		<template slot="title">Centro</template>
		<el-menu-item index="/centro-materiale" class="">Documenti</el-menu-item>
		<el-menu-item index="/centro-profile" class="">Modifica Profilo</el-menu-item>
		<el-menu-item index="/contatto" class="">Gestione Utenti</el-menu-item>
		<el-menu-item v-if="$centro.profile.row.id==1 || $centro.profile.row.id==10001 || $centro.profile.row.step==10" index="/scheda-datigenerali/" class="">Nuova Scheda</el-menu-item>
    
    <el-submenu index="schedecentro">
    <template slot="title">Download Schede</template>
    <li class="el-menu-item" @click="reportSchede(2025)" style="padding-left: 40px;">Download schede 2025</li>
    <li class="el-menu-item" @click="reportSchede(2024)" style="padding-left: 40px;">Download schede 2024</li>
    <li class="el-menu-item" @click="reportSchede(2023)" style="padding-left: 40px;">Download schede 2023</li>
    <li class="el-menu-item" @click="reportSchede(2022)" style="padding-left: 40px;">Download schede 2022</li>
    <li class="el-menu-item" @click="reportSchede(2021)" style="padding-left: 40px;">Download schede 2021</li>
    <li class="el-menu-item" @click="reportSchede(2020)" style="padding-left: 40px;">Download schede 2020</li>
    <li class="el-menu-item" @click="reportSchede(2019)" style="padding-left: 40px;">Download schede 2019</li>
    </el-submenu>
<!--
    <li class="el-menu-item" @click="reportSchede" style="padding-left: 40px;">Download Schede</li>
		
		<el-menu-item v-if="$centro.profile.row.id=1" index="/scheda-perinatale/1" class="">Perinatale</el-menu-item>
		<el-menu-item v-if="$centro.profile.row.id=1" index="/scheda-salaparto/1" class="">Sala Parto</el-menu-item>
		<el-menu-item v-if="$centro.profile.row.id=1" index="/scheda-decorso/1" class="">Decorso</el-menu-item>
		<el-menu-item v-if="$centro.profile.row.id=1" index="/scheda-dimissione/1" class="">Dimissione</el-menu-item>
		<el-menu-item v-if="$centro.profile.row.id=1" index="/scheda-trasferimento/1" class="">Trasferimeto</el-menu-item>
		-->
		</el-submenu>

    <el-submenu index="schedecentri" v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it' || $teras.utente.email=='von@terasmm.it'">
		<template slot="title">Schede e centri</template>
    <li class="el-menu-item" @click="reportSchedeAll(2019)" style="padding-left: 40px;">Download di tutte le schede 2019 (operazione lunga...attendere)</li>
    <li class="el-menu-item" @click="reportSchedeAll(2020)" style="padding-left: 40px;">Download di tutte le schede 2020 (operazione lunga...attendere)</li>
    <li class="el-menu-item" @click="reportSchedeAll(2021)" style="padding-left: 40px;">Download di tutte le schede 2021 (operazione lunga...attendere)</li>
    <li class="el-menu-item" @click="reportSchedeAll(2022)" style="padding-left: 40px;">Download di tutte le schede 2022 (operazione lunga...attendere)</li>
    <li class="el-menu-item" @click="reportSchedeAll(2023)" style="padding-left: 40px;">Download di tutte le schede 2023 (operazione lunga...attendere)</li>
    <li class="el-menu-item" @click="reportSchedeAll(2024)" style="padding-left: 40px;">Download di tutte le schede 2024 (operazione lunga...attendere)</li>
    <li class="el-menu-item" @click="reportSchedeAll(2025)" style="padding-left: 40px;">Download di tutte le schede 2025 (operazione lunga...attendere)</li>
    <li class="el-menu-item" @click="reportCentri" style="padding-left: 40px;">Download di tutti i centri</li>
    <li class="el-menu-item" @click="reportContatti" style="padding-left: 40px;">Download di tutti i contatti</li>
    </el-submenu>

    <li class="el-menu-item" @click="pazienteCheck" v-if="$teras.utente.email=='teras@innsin.it'" style="color:#fff;">Check paziente {{isPaziente}}</li>

		
		
		<!--
			Aggiungere link alla scheda cartaceo: https://docs.biomedia.net/SIN/scheda_innsin.pdf
		-->
		<a :href="'/documenti/scheda_innsin_v18_2025.pdf?random='+$teras.random()"  target="_blank" style="color:#fff;"><li class="el-menu-item">Scheda Cartacea</li> </a>


		<el-menu-item index="/report-basico" v-if="(true || $centro.profile.row.id==1 || $centro.profile.row.id==10001  || $centro.profile.row.id==10024 || $centro.profile.row.id==10050 || $centro.profile.row.id==10069) && $centro.profile.row.step==10">Analizza i tuoi dati</el-menu-item>

<!--
    <el-submenu index="analisi" v-if="(true || $centro.profile.row.id==1 || $centro.profile.row.id==10001  || $centro.profile.row.id==10024 || $centro.profile.row.id==10050 || $centro.profile.row.id==10069) && $centro.profile.row.step==10">
    <template slot="title">Analisi</template>
		<el-menu-item index="/report-basico" class="">Report</el-menu-item>
    </el-submenu>
-->

    <!--
      <el-submenu index="caterpillar" v-if="(true || $centro.profile.row.id==1 || $centro.profile.row.id==10001  || $centro.profile.row.id==10024 || $centro.profile.row.id==10050 || $centro.profile.row.id==10069) && $centro.profile.row.step==10">
    -->
    <el-submenu index="caterpillar" v-if="$centro.profile.row.step==10">
    <template slot="title">Caterpillar Plot</template>
		<el-menu-item index="/caterpillar-fdisp" class="">Mortalità alla dimissione</el-menu-item>
		<el-menu-item index="/caterpillar-steroidi" class="">Uso steroidi prenatali</el-menu-item>
		<el-menu-item index="/caterpillar-temperatura" class="">Standard Temperatura all’ingresso in TIN 36,5-37,5 C° </el-menu-item>
		<el-menu-item index="/caterpillar-eyex" class="">Esame oculare per retinopatia</el-menu-item>
    <el-menu-item index="/caterpillar-lbpath" class="">Infezioni tardive EG 22-31</el-menu-item>
    <!-- <el-menu-item v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it'" index="/caterpillar-lbpath2" class="">Infezioni tardive EG 32-36</el-menu-item> -->
		<el-menu-item index="/caterpillar-bpd" class="">Broncodisplasia polmonare</el-menu-item>
		<el-menu-item index="/caterpillar-nec" class="">Enterocolite necrotizzante</el-menu-item>
		<el-menu-item index="/caterpillar-entfeed" class="">Latte Materno (esclusivo/complementare) alla dimissione EG 22-31</el-menu-item>
		<el-menu-item index="/caterpillar-entfeed2" class="">Latte Materno (esclusivo/complementare) alla dimissione EG 32-36</el-menu-item>
		<el-menu-item index="/caterpillar-vagdel" class="">Taglio Cesareo</el-menu-item>
    </el-submenu>


    <el-submenu index="shrunken" v-if="false && ($centro.profile.row.id==1 || $centro.profile.row.id==10001  || $centro.profile.row.id==10050 || $centro.profile.row.id==10069) && $centro.profile.row.step==10">
    <template slot="title">Shrunken Plot</template>
		<el-menu-item v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it' || $centro.profile.row.id==10001  || $centro.profile.row.id==10050 || $centro.profile.row.id==10069" index="/caterpillar-shrunken-fdisp" class="">Mortalità</el-menu-item>
 <!--   
		<el-menu-item v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it'" index="/caterpillar-steroidi" class="">Steroidi</el-menu-item>
		<el-menu-item v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it'" index="/caterpillar-temperatura" class="">Temperatura</el-menu-item>
		<el-menu-item v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it'" index="/caterpillar-eyex" class="">Esame oculare per retinopatia</el-menu-item>
    <el-menu-item v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it'" index="/caterpillar-lbpath" class="">Infezioni tardive EG 22-31</el-menu-item>
    <el-menu-item v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it'" index="/caterpillar-lbpath2" class="">Infezioni tardive EG 32-36</el-menu-item>
		<el-menu-item v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it'" index="/caterpillar-bpd" class="">Bronco Displasia</el-menu-item>
		<el-menu-item v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it'" index="/caterpillar-nec" class="">NEC</el-menu-item>
		<el-menu-item v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it'" index="/caterpillar-entfeed" class="">Latte Materno alla dimissione EG 22-31</el-menu-item>
		<el-menu-item v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it'" index="/caterpillar-entfeed2" class="">Latte Materno alla dimissione EG 32-36</el-menu-item>
		<el-menu-item v-if="$teras.utente.ruolo==98 || $teras.utente.email=='report@innsin.it' || $teras.utente.email=='teras@innsin.it'" index="/caterpillar-vagdel" class="">Parto Cesareo</el-menu-item>
  -->  
    </el-submenu>

<!-- v-if="($centro.profile.row.id==1 || $centro.profile.row.id==10001  || $centro.profile.row.id==10050 || $centro.profile.row.id==10069) && $centro.profile.row.step==10"  -->
    <el-submenu index="funnel2022" >
    <template slot="title">Funnel Plot 2022</template>
    <el-menu-item index="/funnel-2022" class="">Come leggere il grafico</el-menu-item>
		<el-menu-item index="/funnel-fdisp-grezza-2022" class="">Mortalità grezza tutti i centri</el-menu-item>
		<el-menu-item index="/funnel-fdisp-grezza-plus10-2022" class="">Mortalità grezza, solo centri >= 10 neonati </el-menu-item>
		<el-menu-item index="/funnel-fdisp-aggiustata-2022" class="">Mortalità aggiustata tutti i centri</el-menu-item>
		<el-menu-item index="/funnel-fdisp-aggiustata-plus10-2022" class="">Mortalità aggiustata, solo centri >= 10 neonati </el-menu-item>
    </el-submenu>




<!-- v-if="($centro.profile.row.id==1 || $centro.profile.row.id==10001  || $centro.profile.row.id==10050 || $centro.profile.row.id==10069) && $centro.profile.row.step==10" -->
    <el-submenu index="funnel2021" >
    <template slot="title">Funnel Plot 2021</template>
    <el-menu-item index="/funnel-2021" class="">Come leggere il grafico</el-menu-item>
		<el-menu-item index="/funnel-fdisp-2021" class="">Mortalità alla dimissione per centro. Neonati con EG 22-31 settimane.  </el-menu-item>
		<el-menu-item index="/funnel-steroidi-2021" class="">Utilizzo steroidi prenatali per centro. Neonati con EG 22-31 settimane.  </el-menu-item>
		<el-menu-item index="/funnel-temperatura-2021" class="">Temperatura all’ingresso compresa fra 36,5-37,5 °C per centro.</el-menu-item>
    <el-menu-item index="/funnel-eyex-2021" class="">Esame della retina per centro. Neonati con EG 22-31 settimane.  </el-menu-item>
    <el-menu-item index="/funnel-lbpath-2021" class="">Infezioni tardive (Sepsi e/o meningite e/o Stafilococco coagulasi neg. e/o fungina). Neonati con EG 22-31 settimane.</el-menu-item>
    <el-menu-item index="/funnel-bpd-2021" class="">Displasia Broncopolmonare. Neonati con EG 22-31 settimane. </el-menu-item>
		<el-menu-item index="/funnel-nec-2021" class="">Eterocolite Necrotizzante.  Neonati con EG 22-31 settimane.</el-menu-item>
		<el-menu-item index="/funnel-entfeed-2021" class="">Latte materno (esclusivo/complementare) alla dimissione. Neonati con EG 22-31 </el-menu-item>
		<el-menu-item index="/funnel-entfeed2-2021" class="">Latte materno (esclusivo/complementare) alla dimissione. Neonati con EG 32-36 </el-menu-item>
		<el-menu-item index="/funnel-vagdel-2021" class="">Taglio cesareo. Neonati con EG 32-36</el-menu-item>
    </el-submenu>
		
    <!--  
    <template slot="title">Funnel Plot</template>
		<el-menu-item index="/funnel-fdisp" class="">Mortalità alla dimissione</el-menu-item>
		<el-menu-item index="/funnel-steroidi" class="">Uso steroidi prenatali</el-menu-item>
		<el-menu-item index="/funnel-temperatura" class="">Standard Temperatura all’ingresso in TIN 36,5-37,5 C° </el-menu-item>
   </el-submenu>

    -->
    <!--

    -->
    


		<el-menu-item index="/centro-admin" v-if="$teras.utente.email=='teras@innsin.it' || $teras.utente.ruolo==11">Admin Centri</el-menu-item>
    <el-menu-item index="/paziente-report" v-if="$teras.utente.email=='teras@innsin.it' || $teras.utente.ruolo==11">Report schede</el-menu-item>

    

    <el-menu-item index="/centro-admin" v-if="$teras.utente.email=='von@terasmm.it'">Admin VON</el-menu-item>
    <el-menu-item index="/von-files" v-if="$teras.utente.email=='von@terasmm.it'">File VON</el-menu-item>
    <!--
    tolto il 4 dicembre 2020 per non darlo in mano a Daniela  -->
    <el-menu-item index="/von-import" v-if="$teras.utente.email=='teras@innsin.it' ||  $teras.utente.email=='von@terasmm.it'">Import VON</el-menu-item>
    

		<li class="el-menu-item" @click="$teras.event.emit('logout')">Esci</li>

	</el-menu>
</div>
</template>

<script>

import excel from '../excel'

export default {
  name: 'sidebar',
  data() {
    return {
      loading:{}
      ,isPaziente:1     
    }
  },
  methods:{
    pazienteCheck: async function(){
      let sql = 'CALL paziente_check_risposte_all(→paziente)'
      let oldPaziente = this.isPaziente
      let sqlresult = await this.$axios.query('fetchOne',sql,{paziente: this.isPaziente})
      this.isPaziente = sqlresult.result
      console.log("PRIMA: "+oldPaziente)
      console.log("DOPO: "+this.isPaziente)
      if(oldPaziente!=this.isPaziente)
        this.pazienteCheck()
    },
    reportContatti:async function() {
      var colonne = ['cnt.id AS id'
      ,'cnt.cognome AS cognome'
      ,'cnt.nome AS nome'
      ,'cnt.email AS email'
      ,'cnt.cellulare AS cellulare'
      ,'cnt.centro AS centro'
      ,'codiceministeriale AS codice_ministeriale'
      ,'cr.nome AS nome'
      ,'st.tipo AS tipologia'
      ,'livello'
      ,'cr.address AS indirizzo'
      ,'st.citta AS citta'
      ,'st.regione AS regione'
      ,'st.von AS von_number'
      ]


      var where = []
      where.push('centro!=1 and centro!=10001 AND centro!=10012')
      
 
      
      let sql = 'SELECT '+colonne.join(',')+' FROM contatto AS cnt LEFT JOIN centro AS cr ON cr.id=cnt.centro LEFT JOIN struttura AS st ON st.id=cr.codiceministeriale WHERE '+where.join(' AND ')+' ORDER BY cnt.cognome,cnt.nome'
      var wsSchede = excel.wsNew()
      wsSchede.cell(0,0,'REPORT CONTATTI').cell(1,0,"Generato il "+this.$moment().format('DD MMMM YYYY[ alle ]HH:mm'))

      
      this.$axios.query('fetchAll',sql,{}).then((data) => {
        
        let labels = {}
        let label = ""
        //console.log(this.$teras._variabile)
        for (let variabile of colonne){
            labels[variabile] = variabile
        }

        let excelData = []
        for (let row of data.result){
          excelData.push(row)
        }

        wsSchede.data(excelData,{initRow:7,labels:labels})
        excel.wsClean().wscreate(wsSchede,'CENTRI').save() 

      })

    },
    reportCentri: async function() {
      var colonne = ['cr.id AS id'
      ,'cr.step AS step'
      ,'codiceministeriale AS codice_ministeriale'
      ,'st.von AS von_number'
      ,'cr.nome AS nome'
      ,'st.tipo AS tipologia'
      ,'livello'
      ,'cr.address AS indirizzo'
      ,'st.citta AS citta'
      ,'st.regione AS regione'
      ,'SUM(IF(byear=2019,1,0)) AS schede_2019'
      ,"SUM(IF(byear=2019 AND chiusoil='0000-00-00 00:00:00',1,0)) AS schede_aperte_2019"
      ,'SUM(IF(byear=2020,1,0)) AS schede_2020'
      ,"SUM(IF(byear=2020 AND chiusoil='0000-00-00 00:00:00',1,0)) AS schede_aperte_2020"
      ,'SUM(IF(byear=2021,1,0)) AS schede_2021'
      ,"SUM(IF(byear=2021 AND chiusoil='0000-00-00 00:00:00',1,0)) AS schede_aperte_2021"
      ,'SUM(IF(byear=2022,1,0)) AS schede_2022'
      ,"SUM(IF(byear=2022 AND chiusoil='0000-00-00 00:00:00',1,0)) AS schede_aperte_2022"
      ,'SUM(IF(byear=2023,1,0)) AS schede_2023'
      ,"SUM(IF(byear=2023 AND chiusoil='0000-00-00 00:00:00',1,0)) AS schede_aperte_2023"
      ,'SUM(IF(byear=2024,1,0)) AS schede_2024'
      ,"SUM(IF(byear=2024 AND chiusoil='0000-00-00 00:00:00',1,0)) AS schede_aperte_2024"
      ,'SUM(IF(byear=2025,1,0)) AS schede_2025'
      ,"SUM(IF(byear=2025 AND chiusoil='0000-00-00 00:00:00',1,0)) AS schede_aperte_2025"
      ]


      var where = []
      where.push('cr.id!=1 and cr.id!=10001 AND cr.id!=10012 AND cr.codiceministeriale!=1 AND pz.id>0')
      
 
      
      let sql = 'SELECT '+colonne.join(',')+' FROM centro AS cr LEFT JOIN struttura AS st ON st.id=cr.codiceministeriale LEFT JOIN paziente AS pz ON pz.centro = cr.id WHERE '+where.join(' AND ')+' GROUP BY cr.id ORDER BY cr.id,cr.nome'
      var wsSchede = excel.wsNew()
      wsSchede.cell(0,0,'REPORT SCHEDE').cell(1,0,"Generato il "+this.$moment().format('DD MMMM YYYY[ alle ]HH:mm'))

      
      this.$axios.query('fetchAll',sql,{}).then((data) => {
        
        let labels = {}
        let label = ""
        //console.log(this.$teras._variabile)
        for (let variabile of colonne){
            labels[variabile] = variabile
        }

        let excelData = []
        for (let row of data.result){
          excelData.push(row)
        }

        wsSchede.data(excelData,{initRow:7,labels:labels})
        excel.wsClean().wscreate(wsSchede,'CENTRI').save() 

      })

    },
    reportSchede: async function(year) {
      //this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

      /* COLONNE NON INSERITE
,'centro'
,'creatoil'
,'creatoda'
,'modificatoil'
,'modificatoda'
,'chiusoda'
,'chiusoil'
,'hospno'
,'vonnumber'
,'gruppo AS gruppo'
,'gruppo'

      */

     /*09/04/2020 23:00:00
      var colonne = ['id'
,'ncartellaclinica'
,'byear'
,'cognome'
,'nome'
,'sex'
,'primogenito'
,'datanascita'
,'locate'
,'dataricovero'
,'dayadmiss'
,'outb_ctr'
,'deldie'
,'gaweeks'
,'gadays'
,'bwgt'
,'lunghezzanascita'
,'bheadcir'
,'sga'
,'etamaterna'
,'hisp'
,'matrace'
,'statomadre'
,'titolomadre'
,'hmadre'
,'pmadre'
,'bmimadre'
,'pcare'
,'patomadre'
,'patomadretipo'
,'pma'
,'mhypertens'
,'mdiabetes'
,'aster'
,'tipoaster'
,'amagsulf'
,'iugr'
,'benfetale'
,'mult'
,'nbirths'
,'tttdec'
,'multmonoc'
,'congeninf'
,'congeninfcd1'
,'congeninfcd2'
,'congeninfcd3'
,'chorio'
,'anomplacenta'
,'prom'
,'initrav'
,'vagdel'
,'ap1'
,'ap5'
,'drox'
,'drbm'
,'drlma'
,'dret'
,'drep'
,'drcc'
,'drnimv'
,'drcpap'
,'sli'
,'atempm'
,'atemp'
,'die12'
,'ebseps'
,'ebsepscd1'
,'ebsepscd2'
,'ebsepscd3'
,'lbpath'
,'lbpathwo'
,'lbpathcd1'
,'lbpathcd2'
,'lbpathcd3'
,'cnegstaph'
,'cnegwo'
,'fungal'
,'fungalwo'
,'patoresp'
,'oxy'
,'vent'
,'hfv'
,'hfnc'
,'nimv'
,'cpap'
,'cpapes'
,'drsurf'
,'surfx'
,'surf1dhr'
,'surf1dmin'
,'fio2surf'
,'nsurf'
,'insure'
,'lisa'
,'tipoprelisa'
,'prelisa'
,'ino'
,'inowg'
,'newox28'
,'ox36'
,'vent36'
,'hfv36'
,'hfnc36'
,'nimv36'
,'cpap36'
,'sterbpd'
,'sterbpdwg'
,'apnea'
,'ttn'
,'rds'
,'pntx'
,'pntxwo'
,'bpd'
,'bpdgrado'
,'usound1'
,'ugrade1'
,'pihwfo'
,'pvl'
,'pvlgrado'
,'eyex'
,'istage'
,'ropantivegf'
,'ropsurg'
,'ropsurgwd'
,'pda'
,'ibuprofen'
,'acetamin'
,'indometh'
,'pdasurg'
,'nec'
,'necwo'
,'necsurg'
,'giperf'
,'giperfwo'
,'cmal'
,'bdcd1gruppo'
,'bdcd2gruppo'
,'bdcd3gruppo'
,'bdcd4gruppo'
,'bdcd5gruppo'
,'bdcd1'
,'bdcd2'
,'bdcd3'
,'bdcd4'
,'bdcd5'
,'bdefect'
,'probiotics'
,'caffeine'
,'tcaffeine'
,'gginicaffeine'
,'vitamina'
,'osurg'
,'srgcd1gruppo'
,'srgcd2gruppo'
,'srgcd3gruppo'
,'srgcd4gruppo'
,'srgcd5gruppo'
,'srgcd6gruppo'
,'srgcd7gruppo'
,'srgcd8gruppo'
,'srgcd9gruppo'
,'srgcd10gruppo'
,'srgcd1'
,'srgloc1'
,'srgssi1'
,'srgcd2'
,'srgloc2'
,'srgssi2'
,'srgcd3'
,'srgloc3'
,'srgssi3'
,'srgcd4'
,'srgloc4'
,'srgssi4'
,'srgcd5'
,'srgloc5'
,'srgssi5'
,'srgcd6'
,'srgloc6'
,'srgssi6'
,'srgcd7'
,'srgloc7'
,'srgssi7'
,'srgcd8'
,'srgloc8'
,'srgssi8'
,'srgcd9'
,'srgloc9'
,'srgssi9'
,'srgcd10'
,'srgloc10'
,'srgssi10'
,'osrgdesc'
,'eii'
,'ipotermia'
,'npgg'
,'fef'
,'fefgg'
,'colestasi'
,'epo'
,'ec'
,'dataesito'
,'entfeed'
,'supportodim'
,'oxfinal'
,'fio236'
,'ventfinal'
,'hfvfinal'
,'hfncfinal'
,'nimvfinal'
,'cpapfinal'
,'acfinal'
,'fdisp'
,'dwgt'
,'dheadcir'
,'ldimissione'
,'los1'
,'transcode'
,'xfer_ctr'
,'f2disp'
,'f3disp'
,'udisp'
,'f3wgt'
,'lostot'
,'negg'
,'neconlm'
,'neconla'
,'neconlm_la'
,'digiuno'
,'lmbanca'
,'lmfortificato'
,'proteine'
,'nr_nome'
,'nr_numero'
,'inizionegg'
,'rianimazionedr'
,'dfd'
]
*/


      /* Colonne al 1 dicembre 2020 */
var colonne = ['id'
,'ncartellaclinica'
,'byear'
,'cognome'
,'nome'
,'sex'
,'primogenito'
,'datanascita'
,'locate'
,'dayadmiss'
,'dataricovero'
,'outb_ctr'
,'deldie'
,'gaweeks'
,'gadays'
,'bwgt'
,'sga'
,'lunghezzanascita'
,'bheadcir'
,'etamaterna'
,'hisp'
,'matrace'
,'statomadre'
,'titolomadre'
,'hmadre'
,'pmadre'
,'bmimadre'
,'pcare'
,'patomadre'
,'patomadretipo'
,'pma'
,'mhypertens'
,'mdiabetes'
,'aster'
,'tipoaster'
,'amagsulf'
,'iugr'
,'benfetale'
,'mult'
,'nbirths'
,'tttdec'
,'multmonoc'
,'congeninf'
,'congeninfcd1'
,'congeninfcd2'
,'congeninfcd3'
,'chorio'
,'anomplacenta'
,'prom'
,'initrav'
,'vagdel'
,'ap1'
,'ap5'
,'rianimazionedr'
,'drox'
,'drbm'
,'drlma'
,'dret'
,'drnimv'
,'drcpap'
,'sli'
,'drcc'
,'drep'
,'drsurf'
,'atempm'
,'atemp'
,'die12'
,'ebseps'
,'ebsepscd1'
,'ebsepscd2'
,'ebsepscd3'
,'lbpath'
,'lbpathwo'
,'lbpathcd1'
,'lbpathcd2'
,'lbpathcd3'
,'cnegstaph'
,'cnegwo'
,'fungal'
,'fungalwo'
,'patoresp'
,'oxy'
,'vent'
,'hfv'
,'hfnc'
,'nimv'
,'cpap'
,'cpapes'
,'surfx'
,'surf1dhr'
,'surf1dmin'
,'fio2surf'
,'nsurf'
,'insure'
,'lisa'
,'prelisa'
,'tipoprelisa'
,'ino'
,'inowg'
,'newox28'
,'ox36'
,'fio236'
,'vent36'
,'hfv36'
,'hfnc36'
,'nimv36'
,'cpap36'
,'sterbpd'
,'sterbpdwg'
,'bpd'
,'bpdgrado'
,'apnea'
,'ttn'
,'rds'
,'pntx'
,'pntxwo'
,'usound1'
,'ugrade1'
,'pihwfo'
,'pvl'
,'pvlgrado'
,'eii'
,'ipotermia'
,'eyex'
,'istage'
,'ropantivegf'
,'ropsurg'
,'ropsurgwd'
,'pda'
,'ibuprofen'
,'acetamin'
,'indometh'
,'pdasurg'
,'nec'
,'necwo'
,'giperf'
,'giperfwo'
,'necsurg'
,'cmal'
,'bdcd1gruppo'
,'bdcd1'
,'bdcd2gruppo'
,'bdcd2'
,'bdcd3gruppo'
,'bdcd3'
,'bdcd4gruppo'
,'bdcd4'
,'bdcd5gruppo'
,'bdcd5'
,'bdefect'
,'osurg'
,'srgcd1'
,'srgcd1gruppo'
,'srgloc1'
,'srgssi1'
,'srgcd2'
,'srgcd2gruppo'
,'srgloc2'
,'srgssi2'
,'srgcd3'
,'srgcd3gruppo'
,'srgloc3'
,'srgssi3'
,'srgcd4'
,'srgcd4gruppo'
,'srgloc4'
,'srgssi4'
,'srgcd5'
,'srgcd5gruppo'
,'srgloc5'
,'srgssi5'
,'srgcd6'
,'srgcd6gruppo'
,'srgloc6'
,'srgssi6'
,'srgcd7'
,'srgcd7gruppo'
,'srgloc7'
,'srgssi7'
,'srgcd8'
,'srgcd8gruppo'
,'srgloc8'
,'srgssi8'
,'srgcd9'
,'srgcd9gruppo'
,'srgloc9'
,'srgssi9'
,'srgcd10'
,'srgcd10gruppo'
,'srgloc10'
,'srgssi10'
,'osrgdesc'
,'npgg'
,'negg'
,'inizionegg'
,'neconlm'
,'neconla'
,'neconlm_la'
,'lmbanca'
,'lmfortificato'
,'digiuno'
,'fef'
,'fefgg'
,'proteine'
,'probiotics'
,'colestasi'
,'epo'
,'ec'
,'caffeine'
,'tcaffeine'
,'gginicaffeine'
,'vitamina'
,'dataesito'
,'los1'
,'fdisp'
,'entfeed'
,'supportodim'
,'oxfinal'
,'ventfinal'
,'hfvfinal'
,'hfncfinal'
,'nimvfinal'
,'cpapfinal'
,'acfinal'
,'dwgt'
,'dheadcir'
,'ldimissione'
,'transcode'
,'xfer_ctr'
,'f2disp'
,'f3disp'
,'dfd'
,'f3wgt'
,'lostot'
,'nr_nome'
,'nr_numero'
,'vonnumber'
]


      var where = []
      where.push('byear='+year)
      
 
      where.push('id>0 AND centro='+this.$centro.profile.row.id)
      
      let sql = 'SELECT '+colonne.join(',')+' FROM paziente WHERE '+where.join(' AND ')+' ORDER BY ncartellaclinica,cognome,nome'
      var wsSchede = excel.wsNew()
      wsSchede.cell(0,0,'REPORT SCHEDE').cell(1,0,"Generato il "+this.$moment().format('DD MMMM YYYY[ alle ]HH:mm'))

      
      this.$axios.query('fetchAll',sql,{}).then((data) => {
        
        let labels = {}
        let label = ""
        //console.log(this.$teras._variabile)
        for (let variabile of colonne){
          //console.log((this.$teras.getItemFromArrayObject(variabile,'nome',this.$teras._variabile)).domanda)
          label =  (this.$teras.getItemFromArrayObject(variabile,'nome',this.$teras._variabile)).domanda
          //console.log(variabile+' » '+label)
          if(typeof label != 'undefined'){
            label = label.replace("<div class=\"title_h1 yo-color-secondary\">","")
            label = label.replace("</div>","")
            labels[variabile] = label
          }
          

        }

        let variabileRow = {}
        let risposteObj = {}
        let excelData = []
        for (let row of data.result){
          for (let variabile of colonne){
          //console.log((this.$teras.getItemFromArrayObject(variabile,'nome',this.$teras._variabile)).domanda)
            //variabileRow = this.$teras.getItemFromArrayObject(variabile,'nome',this.$teras._variabile)
            //if(variabileRow.tipo==3 && variabileRow.answer!=''){


            variabileRow = this.$teras.getItemFromArrayObject(variabile,'nome',this.$teras._variabile)
            if(variabileRow.tipo==3 && variabileRow.answer!='' && row[variabile]!='-127' && row[variabile]!='-7' && row[variabile]!='-9'){
              //console.log(variabile+' » '+variabileRow.answer)

              let risposteObj = []
              switch(variabile) {
              case 'statomadre':
              risposteObj = this.$nazioni
              break

              case 'bdcd1gruppo':
              case 'bdcd2gruppo':
              case 'bdcd3gruppo':
              case 'bdcd4gruppo':
              case 'bdcd5gruppo':
              case 'bdcd1':
              case 'bdcd2':
              case 'bdcd3':
              case 'bdcd4':
              case 'bdcd5':
              for (let item of this.$teras._anomaliecongenite){
                //if(item.parente==this.gruppo) 
                    risposteObj.push(item)
              }
              break

              
              case 'srgcd1gruppo':
              case 'srgcd2gruppo':
              case 'srgcd3gruppo':
              case 'srgcd4gruppo':
              case 'srgcd5gruppo':
              case 'srgcd6gruppo':
              case 'srgcd7gruppo':
              case 'srgcd8gruppo':
              case 'srgcd9gruppo':
              case 'srgcd10gruppo':
              case 'srgcd1':
              case 'srgcd2':
              case 'srgcd3':
              case 'srgcd4':
              case 'srgcd5':
              case 'srgcd6':
              case 'srgcd7':
              case 'srgcd8':
              case 'srgcd9':
              case 'srgcd10':
              for (let item of this.$teras._interventichirurgici){
                //if(item.parente==this.gruppo) 
                    risposteObj.push(item)
              }
              break
              
              

              default:
              risposteObj = JSON.parse(variabileRow.answer)
              }


              row[variabile] = (this.$teras.getItemFromArrayObject(row[variabile],'id',risposteObj)).label
            }

            if(row[variabile] == '-127' || row[variabile] == -127)
              row[variabile] = 'NR'
            
            if(row[variabile] == '-9' || row[variabile] == -9)
              row[variabile] = 'NC'
            
            if(row[variabile] == '-7' || row[variabile] == -7)
              row[variabile] = 'NA'
          }
          excelData.push(row)
        }
        

        //console.log(data.result)

        //let item = this.$teras.getItemFromArrayObject(this.variabile,'nome',this.$teras._variabile)


        //var campi = ['address','cognome','nome','email','id','cellulare']
        //var labels = ['DATA INIZIO','MINUTI','IN AVVIO','ESITO','TIPO COSTO','COSTO','UTENTE','TEAMWORK','DESCRIZIONE']
        wsSchede.data(excelData,{initRow:7,labels:labels})
        //this.loading.close()
        excel.wsClean().wscreate(wsSchede,'SCHEDE').save() 

      })



    },


    reportSchedeAll: async function(year) {
      //this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

      /* COLONNE NON INSERITE

,'hospno'
,'creatoil'
,'creatoda'
,'modificatoil'
,'modificatoda'
,'chiusoda'
,'chiusoil'
,'vonnumber'
,'gruppo AS gruppo'
,'gruppo'

      */
/*
      var colonne = ['id'
,'centro'
,'ncartellaclinica'
,'byear'
,'chiusoil'
,'cognome'
,'nome'
,'sex'
,'primogenito'
,'datanascita'
,'locate'
,'dataricovero'
,'dayadmiss'
,'outb_ctr'
,'deldie'
,'gaweeks'
,'gadays'
,'bwgt'
,'lunghezzanascita'
,'bheadcir'
,'sga'
,'etamaterna'
,'hisp'
,'matrace'
,'statomadre'
,'titolomadre'
,'hmadre'
,'pmadre'
,'bmimadre'
,'pcare'
,'patomadre'
,'patomadretipo'
,'pma'
,'mhypertens'
,'mdiabetes'
,'aster'
,'tipoaster'
,'amagsulf'
,'iugr'
,'benfetale'
,'mult'
,'nbirths'
,'tttdec'
,'multmonoc'
,'congeninf'
,'congeninfcd1'
,'congeninfcd2'
,'congeninfcd3'
,'chorio'
,'anomplacenta'
,'prom'
,'initrav'
,'vagdel'
,'ap1'
,'ap5'
,'drox'
,'drbm'
,'drlma'
,'dret'
,'drep'
,'drcc'
,'drnimv'
,'drcpap'
,'sli'
,'atempm'
,'atemp'
,'die12'
,'ebseps'
,'ebsepscd1'
,'ebsepscd2'
,'ebsepscd3'
,'lbpath'
,'lbpathwo'
,'lbpathcd1'
,'lbpathcd2'
,'lbpathcd3'
,'cnegstaph'
,'cnegwo'
,'fungal'
,'fungalwo'
,'patoresp'
,'oxy'
,'vent'
,'hfv'
,'hfnc'
,'nimv'
,'cpap'
,'cpapes'
,'drsurf'
,'surfx'
,'surf1dhr'
,'surf1dmin'
,'fio2surf'
,'nsurf'
,'insure'
,'lisa'
,'tipoprelisa'
,'prelisa'
,'ino'
,'inowg'
,'newox28'
,'ox36'
,'vent36'
,'hfv36'
,'hfnc36'
,'nimv36'
,'cpap36'
,'sterbpd'
,'sterbpdwg'
,'apnea'
,'ttn'
,'rds'
,'pntx'
,'pntxwo'
,'bpd'
,'bpdgrado'
,'usound1'
,'ugrade1'
,'pihwfo'
,'pvl'
,'pvlgrado'
,'eyex'
,'istage'
,'ropantivegf'
,'ropsurg'
,'ropsurgwd'
,'pda'
,'ibuprofen'
,'acetamin'
,'indometh'
,'pdasurg'
,'nec'
,'necwo'
,'necsurg'
,'giperf'
,'giperfwo'
,'cmal'
,'bdcd1gruppo'
,'bdcd2gruppo'
,'bdcd3gruppo'
,'bdcd4gruppo'
,'bdcd5gruppo'
,'bdcd1'
,'bdcd2'
,'bdcd3'
,'bdcd4'
,'bdcd5'
,'bdefect'
,'probiotics'
,'caffeine'
,'tcaffeine'
,'gginicaffeine'
,'vitamina'
,'osurg'
,'srgcd1gruppo'
,'srgcd2gruppo'
,'srgcd3gruppo'
,'srgcd4gruppo'
,'srgcd5gruppo'
,'srgcd6gruppo'
,'srgcd7gruppo'
,'srgcd8gruppo'
,'srgcd9gruppo'
,'srgcd10gruppo'
,'srgcd1'
,'srgloc1'
,'srgssi1'
,'srgcd2'
,'srgloc2'
,'srgssi2'
,'srgcd3'
,'srgloc3'
,'srgssi3'
,'srgcd4'
,'srgloc4'
,'srgssi4'
,'srgcd5'
,'srgloc5'
,'srgssi5'
,'srgcd6'
,'srgloc6'
,'srgssi6'
,'srgcd7'
,'srgloc7'
,'srgssi7'
,'srgcd8'
,'srgloc8'
,'srgssi8'
,'srgcd9'
,'srgloc9'
,'srgssi9'
,'srgcd10'
,'srgloc10'
,'srgssi10'
,'osrgdesc'
,'eii'
,'ipotermia'
,'npgg'
,'fef'
,'fefgg'
,'colestasi'
,'epo'
,'ec'
,'dataesito'
,'entfeed'
,'supportodim'
,'oxfinal'
,'fio236'
,'ventfinal'
,'hfvfinal'
,'hfncfinal'
,'nimvfinal'
,'cpapfinal'
,'acfinal'
,'fdisp'
,'dwgt'
,'dheadcir'
,'ldimissione'
,'los1'
,'transcode'
,'xfer_ctr'
,'f2disp'
,'f3disp'
,'udisp'
,'f3wgt'
,'lostot'
,'negg'
,'neconlm'
,'neconla'
,'neconlm_la'
,'digiuno'
,'lmbanca'
,'lmfortificato'
,'proteine'
,'inizionegg'
,'rianimazionedr'
,'dfd'
,'gruppo'
,'nr_nome'
,'nr_numero'


,'cognome'
,'nome'
,'ncartellaclinica'
]
*/
/* Colonne al 1 dicembre 2020 */
var colonne = ['id'
,'centro'
,'chiusoil'
,'byear'
,'sex'
,'primogenito'
,'datanascita'
,'locate'
,'dayadmiss'
,'dataricovero'
,'outb_ctr'
,'deldie'
,'gaweeks'
,'gadays'
,'bwgt'
,'sga'
,'lunghezzanascita'
,'bheadcir'
,'etamaterna'
,'hisp'
,'matrace'
,'statomadre'
,'titolomadre'
,'hmadre'
,'pmadre'
,'bmimadre'
,'pcare'
,'patomadre'
,'patomadretipo'
,'pma'
,'mhypertens'
,'mdiabetes'
,'aster'
,'tipoaster'
,'amagsulf'
,'iugr'
,'benfetale'
,'mult'
,'nbirths'
,'tttdec'
,'multmonoc'
,'congeninf'
,'congeninfcd1'
,'congeninfcd2'
,'congeninfcd3'
,'chorio'
,'anomplacenta'
,'prom'
,'initrav'
,'vagdel'
,'ap1'
,'ap5'
,'rianimazionedr'
,'drox'
,'drbm'
,'drlma'
,'dret'
,'drnimv'
,'drcpap'
,'sli'
,'drcc'
,'drep'
,'drsurf'
,'atempm'
,'atemp'
,'die12'
,'ebseps'
,'ebsepscd1'
,'ebsepscd2'
,'ebsepscd3'
,'lbpath'
,'lbpathwo'
,'lbpathcd1'
,'lbpathcd2'
,'lbpathcd3'
,'cnegstaph'
,'cnegwo'
,'fungal'
,'fungalwo'
,'patoresp'
,'oxy'
,'vent'
,'hfv'
,'hfnc'
,'nimv'
,'cpap'
,'cpapes'
,'surfx'
,'surf1dhr'
,'surf1dmin'
,'fio2surf'
,'nsurf'
,'insure'
,'lisa'
,'prelisa'
,'tipoprelisa'
,'ino'
,'inowg'
,'newox28'
,'ox36'
,'fio236'
,'vent36'
,'hfv36'
,'hfnc36'
,'nimv36'
,'cpap36'
,'sterbpd'
,'sterbpdwg'
,'bpd'
,'bpdgrado'
,'apnea'
,'ttn'
,'rds'
,'pntx'
,'pntxwo'
,'usound1'
,'ugrade1'
,'pihwfo'
,'pvl'
,'pvlgrado'
,'eii'
,'ipotermia'
,'eyex'
,'istage'
,'ropantivegf'
,'ropsurg'
,'ropsurgwd'
,'pda'
,'ibuprofen'
,'acetamin'
,'indometh'
,'pdasurg'
,'nec'
,'necwo'
,'giperf'
,'giperfwo'
,'necsurg'
,'cmal'
,'bdcd1gruppo'
,'bdcd1'
,'bdcd2gruppo'
,'bdcd2'
,'bdcd3gruppo'
,'bdcd3'
,'bdcd4gruppo'
,'bdcd4'
,'bdcd5gruppo'
,'bdcd5'
,'bdefect'
,'osurg'
,'srgcd1'
,'srgcd1gruppo'
,'srgloc1'
,'srgssi1'
,'srgcd2'
,'srgcd2gruppo'
,'srgloc2'
,'srgssi2'
,'srgcd3'
,'srgcd3gruppo'
,'srgloc3'
,'srgssi3'
,'srgcd4'
,'srgcd4gruppo'
,'srgloc4'
,'srgssi4'
,'srgcd5'
,'srgcd5gruppo'
,'srgloc5'
,'srgssi5'
,'srgcd6'
,'srgcd6gruppo'
,'srgloc6'
,'srgssi6'
,'srgcd7'
,'srgcd7gruppo'
,'srgloc7'
,'srgssi7'
,'srgcd8'
,'srgcd8gruppo'
,'srgloc8'
,'srgssi8'
,'srgcd9'
,'srgcd9gruppo'
,'srgloc9'
,'srgssi9'
,'srgcd10'
,'srgcd10gruppo'
,'srgloc10'
,'srgssi10'
,'osrgdesc'
,'npgg'
,'negg'
,'inizionegg'
,'neconlm'
,'neconla'
,'neconlm_la'
,'lmbanca'
,'lmfortificato'
,'digiuno'
,'fef'
,'fefgg'
,'proteine'
,'probiotics'
,'colestasi'
,'epo'
,'ec'
,'caffeine'
,'tcaffeine'
,'gginicaffeine'
,'vitamina'
,'dataesito'
,'los1'
,'fdisp'
,'entfeed'
,'supportodim'
,'oxfinal'
,'ventfinal'
,'hfvfinal'
,'hfncfinal'
,'nimvfinal'
,'cpapfinal'
,'acfinal'
,'dwgt'
,'dheadcir'
,'ldimissione'
,'transcode'
,'xfer_ctr'
,'f2disp'
,'f3disp'
,'dfd'
,'f3wgt'
,'lostot'
,'nr_nome'
,'nr_numero'
,'vonnumber'
]


      var where = []
      where.push('byear='+year)
      //where.push('chiusoil>0 AND creatoda>0')
      //where.push('chiusoil>0 AND creatoda=0')
      
 
      where.push('id>0 AND centro!=1 and centro!=10001 AND centro!=10012')
      
      let sql = 'SELECT '+colonne.join(',')+' FROM paziente WHERE '+where.join(' AND ')+' ORDER BY ncartellaclinica,cognome,nome'
      
      var wsSchede = excel.wsNew()
      wsSchede.cell(0,0,'REPORT SCHEDE').cell(1,0,"Generato il "+this.$moment().format('DD MMMM YYYY[ alle ]HH:mm'))

      console.log(sql)
      let data = await this.$axios.query('fetchAll',sql,{})//.then((data) => {

        
        
        let labels = {}
        let label = ""
        for (let variabile of colonne){
          label =  (this.$teras.getItemFromArrayObject(variabile,'nome',this.$teras._variabile)).domanda

          if(typeof label != 'undefined'){
            /*
            label = label.replace("<div class=\"title_h1 yo-color-secondary\">","")
            label = label.replace("</div>","")
            labels[variabile] = label
            */
            labels[variabile] = variabile
          }
          

        }

        let variabileRow = {}
        let risposteObj = {}
        let excelData = []
        
        for (let row of data.result){
          for (let variabile of colonne){
            
            //console.log((this.$teras.getItemFromArrayObject(variabile,'nome',this.$teras._variabile)).domanda)
            /**/
            variabileRow = this.$teras.getItemFromArrayObject(variabile,'nome',this.$teras._variabile)
            if(variabileRow.tipo==3 && variabileRow.answer!='' && row[variabile]!='-127' && row[variabile]!='-7' && row[variabile]!='-9'){
              
              //console.log(variabile+' » '+variabileRow.answer)


              let risposteObj = []
              switch(variabile) {
              case 'statomadre':
              risposteObj = this.$nazioni
              break

              case 'bdcd1gruppo':
              case 'bdcd2gruppo':
              case 'bdcd3gruppo':
              case 'bdcd4gruppo':
              case 'bdcd5gruppo':
              case 'bdcd1':
              case 'bdcd2':
              case 'bdcd3':
              case 'bdcd4':
              case 'bdcd5':
              for (let item of this.$teras._anomaliecongenite){
                //if(item.parente==this.gruppo) 
                    risposteObj.push(item)
              }
              break

              
              case 'srgcd1gruppo':
              case 'srgcd2gruppo':
              case 'srgcd3gruppo':
              case 'srgcd4gruppo':
              case 'srgcd5gruppo':
              case 'srgcd6gruppo':
              case 'srgcd7gruppo':
              case 'srgcd8gruppo':
              case 'srgcd9gruppo':
              case 'srgcd10gruppo':
              case 'srgcd1':
              case 'srgcd2':
              case 'srgcd3':
              case 'srgcd4':
              case 'srgcd5':
              case 'srgcd6':
              case 'srgcd7':
              case 'srgcd8':
              case 'srgcd9':
              case 'srgcd10':
              for (let item of this.$teras._interventichirurgici){
                //if(item.parente==this.gruppo) 
                    risposteObj.push(item)
              }
              break
              
              

              default:
              risposteObj = JSON.parse(variabileRow.answer)
              }

          
              //risposteObj = JSON.parse(variabileRow.answer)
              /*
              if(variabile=='matrace'){
                console.error(row[variabile])
                console.log(risposteObj)
              }*/
              row[variabile] = (this.$teras.getItemFromArrayObject(row[variabile],'id',risposteObj)).label
            }
            
            if(row[variabile] == '-127' || row[variabile] == -127)
              row[variabile] = 'NR'
            
            if(row[variabile] == '-9' || row[variabile] == -9)
              row[variabile] = 'NC'
            
            if(row[variabile] == '-7' || row[variabile] == -7)
              row[variabile] = 'NA'
            
          }
          
          excelData.push(row)
        }
        

        //console.log(data.result)

        //let item = this.$teras.getItemFromArrayObject(this.variabile,'nome',this.$teras._variabile)


        //var campi = ['address','cognome','nome','email','id','cellulare']
        //var labels = ['DATA INIZIO','MINUTI','IN AVVIO','ESITO','TIPO COSTO','COSTO','UTENTE','TEAMWORK','DESCRIZIONE']
        wsSchede.data(excelData,{initRow:7,labels:labels})
        //this.loading.close()


        let wsVariabili = excel.wsNew()

        let variabiliData = await this.$axios.query('fetchAll',`SELECT LOWER(nome) AS nome, gruppo, von  FROM variabile WHERE nome!="id" AND scheda>0 AND scheda <10 AND step=10 ORDER BY nome`,{})
        wsVariabili.data(variabiliData.result,{initRow:0,labels:labels})

        excel.wsClean().wscreate(wsSchede,'SCHEDE').wscreate(wsVariabili,'ELENCO VARIBILI').save() 

      //})



    }

  }
}

</script>

<style >
.sidebar-menu{
  
}.el-menu{
	background:#3E69B9 !important;
	border:none !important;
}.sidebar-menu .el-menu{
  border:none !important;
}.el-submenu__title i{
	color:#fff !important;
}.app-side-menu .el-menu-item, .app-side-menu  .el-submenu__title{
  color:#ffffff;
  font-size: 1.8rem;
  height: 46px;
  line-height: 46px;
}.app-side-menu .el-menu-item.is-active{
  color:#ffffff;
}.app-side-menu .el-submenu .el-menu-item:hover  {
  color:#3E69B9 !important;
}.app-side-menu .el-menu-item:hover, .app-side-menu .el-submenu__title:hover{
	color:#ffffff;
	background:rgb(146, 172, 202) !important;
}.app-side-menu .el-submenu .el-menu li{
  color:#3E69B9;
  line-height: initial;
  padding: 10px 0;
  background: #BDD1E8;
}.app-side-menu .el-submenu .el-menu li i{
  position:fixed;
  left: 15px;
  margin:2px 0 0 0;
  display:none;
}
</style>
